import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

/**
 * Generated class for the ConfigurationPaymentCryptoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-crypto',
  templateUrl: 'configuration-payment-crypto.html',
})
export class ConfigurationPaymentCryptoPage {

  public crypto_api: string = '';
  public crypto_webhook: string = '';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    private http: HttpClient,) {

    //notificacion de interes sobre el pay
    if(!this.globals.restaurant.payment_method_crypto || this.globals.restaurant.payment_method_crypto == undefined){
      this.notificationSlack();
    }
  }

  ionViewWillEnter() {
    if (this.globals.restaurant.payment_method_crypto_api != undefined) {
      this.crypto_api = this.globals.restaurant.payment_method_crypto_api;
    }
    if (this.globals.restaurant.payment_method_crypto_webhook != undefined) {
      this.crypto_webhook = this.globals.restaurant.payment_method_crypto_webhook;
    }
  }

  changeCrypto(active) {
    if (this.crypto_api != '' && this.crypto_webhook != '') {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_crypto': active
      }).then(() => {
        this.globals.restaurant.payment_method_crypto = active;
      });
      if (active) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('pay-crypto-activado'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }
    } else {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_crypto': false
      }).then(() => {
        this.globals.restaurant.payment_method_crypto = false;
      });
      let toast = this.toastCtrl.create({
        message: this.translate.instant('pay-crypto-no-podemos-activar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  save() {
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'payment_method_crypto_api': this.crypto_api,
      'payment_method_crypto_webhook': this.crypto_webhook,
    }).then(() => {
      this.globals.restaurant.payment_method_crypto_api = this.crypto_api;
      this.globals.restaurant.payment_method_crypto_webhook = this.crypto_webhook;

      if (this.crypto_api != '' && this.crypto_webhook != '') {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-guardado-correctamente'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
        this.changeCrypto(true);
      } else {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('pay-crypto-completar-campo'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
        this.changeCrypto(false);
      }


    });
  }

  async notificationSlack() {
    var msg = 'El usuario ' + this.globals.restaurant.company + ', ' + this.globals.restaurant.name + ' (' + this.globals.restaurant.email + ') ha abierto el config de Pay Crypto.';

    //send
    await this.http.post(this.globals.api_path + 'slack/integrations', {
      msg: msg,
    }, {}).subscribe(async data => {
    },
      err => {}
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-crypto/configuration-payment-crypto.ts